import React, { useState } from "react";
import { Trash2, UserPlus } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../../../lib/api";
import { D, Chip, Btn, inputStyle, fmtTime } from "../../ui";

const KOTA = ["", "ngawi", "magetan", "madiun", "nganjuk", "kediri", "ponorogo", "pacitan", "trenggalek", "tulungagung", "blitar"];
const SUMBER = { komentar: ["blue", "Komentar IG"], admin: ["gray", "Admin"], dm: ["gray", "DM"] };

// Antrean pendatang: tambah manual (langsung dapat kursi), daftar terbaru dengan nomor penerbangan & jam, hapus
export function BandaraPendatang({ token, d, onChanged }) {
  const [form, setForm] = useState({ username: "", kota: "" });
  const [busy, setBusy] = useState(false);

  async function tambah(e) {
    e.preventDefault();
    if (!form.username.trim()) return;
    setBusy(true);
    try {
      const p = await api.adminPendatangTambah(token, { username: form.username.trim(), kota: form.kota || null });
      toast.success(`@${p.username} dapat kursi ${p.nomor} · ${p.berangkat_wib} WIB`);
      setForm({ username: "", kota: "" }); onChanged();
    } catch (err) { toast.error(err.message); }
    setBusy(false);
  }
  async function hapus(u) {
    if (!window.confirm(`Hapus @${u} dari antrean & penerbangannya?`)) return;
    try { await api.adminPendatangHapus(token, u); toast.success(`@${u} dihapus`); onChanged(); } catch (err) { toast.error(err.message); }
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      <form onSubmit={tambah} data-testid="bandara-tambah-form" style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
        <input data-testid="bandara-tambah-username" value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} placeholder="@username" required style={{ ...inputStyle, flex: 1, minWidth: 150, padding: "9px 12px" }} />
        <select data-testid="bandara-tambah-kota" value={form.kota} onChange={e => setForm({ ...form, kota: e.target.value })} style={{ ...inputStyle, width: 150, padding: "9px 12px" }}>
          {KOTA.map(k => <option key={k} value={k}>{k ? k.charAt(0).toUpperCase() + k.slice(1) : "Kota acak"}</option>)}
        </select>
        <Btn type="submit" small testid="bandara-tambah-submit" disabled={busy || !form.username.trim()}><UserPlus size={13} /> Beri kursi</Btn>
      </form>
      <div data-testid="bandara-pendatang" style={{ display: "flex", flexDirection: "column", gap: 6, maxHeight: 300, overflowY: "auto", paddingRight: 2 }}>
        {d.pendatang.map(p => {
          const label = (SUMBER[p.sumber] || ["gray", p.sumber])[1];
          return (
            <div key={p.username} data-testid={`bandara-pendatang-${p.username}`} style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 12px", borderRadius: 14, background: D.cream, fontSize: 12.5 }}>
              <span style={{ width: 10, height: 10, borderRadius: 99, background: p.warna || D.gray, flex: "none" }} title={p.warna || "warna wilayah"} />
              <b style={{ color: D.ink, flex: 1, minWidth: 110, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={`${label} · ${fmtTime(p.created_at)}`}>@{p.username}</b>
              <span style={{ color: D.sub, textTransform: "capitalize", width: 78, flex: "none" }}>{p.kota}</span>
              <span style={{ width: 118, flex: "none" }}><b style={{ color: D.blue }}>{p.nomor || "—"}</b>{p.berangkat_wib && <span style={{ color: D.ink, fontWeight: 700 }}> · {p.berangkat_wib}</span>}</span>
              <Chip tone={p.diterbangkan ? "green" : "amber"}>{p.diterbangkan ? "Sudah terjun" : "Menunggu"}</Chip>
              <span style={{ color: D.sub, fontSize: 11, flex: "none", width: 36, textAlign: "right" }} title={label}>{p.sumber === "komentar" ? "IG" : p.sumber}</span>
              <button data-testid={`bandara-hapus-${p.username}`} onClick={() => hapus(p.username)} title="Hapus" style={{ border: 0, background: "transparent", color: D.danger, cursor: "pointer", display: "grid", placeItems: "center", padding: 4 }}><Trash2 size={13} /></button>
            </div>
          );
        })}
        {!d.pendatang.length && <p data-testid="bandara-pendatang-kosong" style={{ margin: 0, fontSize: 13, color: D.sub }}>Belum ada pendatang.</p>}
      </div>
    </div>
  );
}
